import React from 'react';
import { FixedActionsContainer } from './FixedActions.styles';

export const FixedActions = ({ children }) => <FixedActionsContainer>{children}</FixedActionsContainer>;
